import { PATH_ROUTES } from 'routes/path';

export enum MILESTONES {
  TNC = 'tnc',
  USER_DETAIL = 'user-detail',
  FIRST_HEALTH_MEASUREMENT = 'first-health-measurement',
  QUESTIONNAIRE = 'questionair',
  ONBOARDED = 'onboarded',
}

// export const VitalSignTypes = {
//   HEART_RATE: 0x1,
//   BREATHING_RATE: 0x2,
//   OXYGEN_SATURATION: 0x4,
//   SDNN: 0x8,
//   STRESS_LEVEL: 0x10,
//   RRI: 0x20,
//   BLOOD_PRESSURE: 0x40,
//   STRESS_INDEX: 0x80,
//   MEAN_RRI: 0x100,
//   RMSSD: 0x200,
//   SD1: 0x400,
//   SD2: 0x800,
//   PRQ: 0x1000,
//   PNS_INDEX: 0x2000,
//   PNS_ZONE: 0x4000,
//   SNS_INDEX: 0x8000,
//   SNS_ZONE: 0x10000,
//   WELLNESS_INDEX: 0x20000,
//   WELLNESS_LEVEL: 0x40000,
//   LFHF: 0x80000,
//   HEMOGLOBIN: 0x100000,
//   HEMOGLOBIN_A1C: 0x200000,
// };

export const VitalSignTypes = {
  PULSE_RATE: 0x1,
  RESPIRATION_RATE: 0x2,
  OXYGEN_SATURATION: 0x4,
  SDNN: 0x8,
  STRESS_LEVEL: 0x10,
  RRI: 0x20,
  BLOOD_PRESSURE: 0x40,
  STRESS_INDEX: 0x80,
  MEAN_RRI: 0x100,
  RMSSD: 0x200,
  SD1: 0x400,
  SD2: 0x800,
  PRQ: 0x1000,
  PNS_INDEX: 0x2000,
  PNS_ZONE: 0x4000,
  SNS_INDEX: 0x8000,
  SNS_ZONE: 0x10000,
  WELLNESS_INDEX: 0x20000,
  WELLNESS_LEVEL: 0x40000,
  LFHF: 0x80000,
  HEMOGLOBIN: 0x100000,
  HEMOGLOBIN_A1C: 0x200000,
  DIABETES_RISK: 0x800000,
  HYPERTENSION_RISK: 0x1000000,
  LOW_HEMOGLOBIN_RISK: 0x2000000,
  HIGH_HEMOGLOBIN_A1C_RISK: 0x4000000,
  HIGH_FASTING_GLUCOSE_RISK: 0x8000000,
  HIGH_BLOOD_PRESSURE_RISK: 0x10000000,
  HIGH_TOTAL_CHOLESTEROL_RISK: 0x20000000,
  CARDIAC_WORKLOAD: 0x40000000,
  PULSE_PRESSURE: 0x80000000,
  MEAN_ARTERIAL_PRESSURE: 0x100000000,
};

export const HIDE_NAV_PATHS = [PATH_ROUTES.PROFILE, PATH_ROUTES.PROFILE + '/'];

export enum WALKTHROUGH_CHECK {
  SIDEMENU = 'sidemenu',
  DASHBOARD = 'dashboard',
  FACE_SCAN_WITH_DETAILS = 'face-scan-with-details',
}

export const ENG_NONE_OF_ABOVE = 'None of the above';
export const ES_NONE_OF_ABOVE = 'Ninguna de las anteriores';

export const NUMERIC_REGEX = /^(?:[1-9][0-9]*)?$/;

export enum QUESTIONNAIRE_CODE {
  BODY_TYPE = 'body_type',
  FITNESS_LEVEL = 'physical_activity',
  SLEEP_LEVEL = 'sleep_level',
  SLEEP_QUALITY = 'sleep_quality',
  STRESS_LEVELS = 'stress_level',
  EATING_HABITS = 'eating_habits',
  WATER_CONSUMPTION = 'water_intake',
  ALCOHOL_CONSUMPTION = 'alcohol_consumption',
  SMOKING = 'smoking',
  // MEDICAL_CONDITIONS = 'medical_history',
  MEDICAL_CONDITIONS = 'medical_condition',
  SPECIFY_MEDICAL_CONDITION = 'medical_condition_search',
  FAMILY_MEDICAL_CONDITIONS = 'family_medical_history',
  ONGOING_ALLERGIES = 'allergies',
  SURGERY = 'surgery',
  TAKING_MEDICATIONS = 'medications',
  SPECIFY_MEDICATION = 'medications_search',
  FACESCAN = 'facescan',
  SPECIFY_MEDICATIONS = 'medications_search',
}

export const ENGLISH_OTHER = 'Other';
export const SPANISH_OTHER = 'Otro';
export const ENGLISH_YES = 'Yes';
export const SPANISH_YES = 'Si';
export const ENGLISH_NONE_OF_THE_ABOVE = 'None of the above';
export const SPANISH_NONE_OF_THE_ABOVE = 'Ninguna de las anteriores';
export const ENGLISH_SPECIFIC_DIETARY_REGIMEN =
  'I follow a specific dietary regimen (e.g., Vegan, Keto, Gluten-free)';
export const SPANISH_SPECIFIC_DIETARY_REGIMEN =
  'Sigo una dieta específica por motivos personales o de salud (e.g. Vegano, Keto, Sin Gluten)';

export const EMOTION_ICON_COLORS = [
  '#F43F5E',
  '#D97706',
  '#FBBF24',
  '#14B8A6',
  '#0F766E',
];
